import { UsersPreferenceData } from 'src/store/interface';
import {
  setLocalStorage,
  setSessionStorage
} from 'src/utils/browserStorageHandler';
import { DynamicObject } from 'src/utils/commonTypes';
import {
  AGGREGATED_USER_BASE_ADDRESS,
  AUTH_BASE_URL
} from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS,
  HTTP_URL_PARAMS
} from 'src/utils/constants/HttpMethodsConstants';
import {
  SETTINGS,
  USER_CONSENTS
} from 'src/utils/constants/localStorageConstants';

import { getAPIHeaders } from './Login/LoginService';
import SimpleStore from '../../store/SimpleStore';
import { DisplayLanguage } from '../../utils/constants/stringConstants';
import { httpService } from '../fetch/HttpService';

export const fetchUserData = async () => {
  const headers = [HTTP_HEADER_KEYS.DEVICE_ID, HTTP_HEADER_KEYS.ESK];
  try {
    return httpService.fetchApiData({
      url: AUTH_BASE_URL,
      type: HTTP_METHODS.GET,
      headers
    });
  } catch (error) {
    return await httpService.logApiError(error);
  }
};

// Get Aggrigated user details user and settings data
export const getInitialUserData = async (
  setUsersPreferenceData: (props: UsersPreferenceData) => void
) => {
  const headers = getAPIHeaders();
  const aggregatedUserDetails = await httpService.fetchApiData({
    url: `${AGGREGATED_USER_BASE_ADDRESS}/?platform_name=web_app`,
    type: HTTP_METHODS.GET,
    headers
  });

  if (aggregatedUserDetails?.settings) {
    /*
    As we are currently reading settings from localstorage in subscription page,
    so following same approch
    */
    setLocalStorage(SETTINGS, aggregatedUserDetails.settings);
  }

  if (aggregatedUserDetails?.info) {
    /*
    Updating user info to usersPreferenceData as both are same
    */
    setUsersPreferenceData(aggregatedUserDetails.info);
    setSessionStorage(USER_CONSENTS, aggregatedUserDetails.info);

    SimpleStore.set(
      HTTP_URL_PARAMS.DISPLAY_LANGUAGE,
      aggregatedUserDetails.info.display_language || DisplayLanguage.ENGLISH
    );
    SimpleStore.set(
      HTTP_URL_PARAMS.CONTENT_LANGUAGE,
      aggregatedUserDetails.info.content_language || DisplayLanguage.ENGLISH
    );
  }
  return aggregatedUserDetails;
};
